'use client'

import { useMemo, useState } from 'react'

import { NOTIFICATION_DRAWER_FILTER } from '../notification-drawer.const'
import type { Notification, NotificationDrawerFilter } from '../notification-drawer.type'
import { filterNotificationsByReadState } from '../utils/filterNotificationsByReadState'
import { sortNotificationsBySeverity } from '../utils/sortNotificationsBySeverity'

type Params = {
  notifications: Notification[]
}

export function useNotificationDrawerFilters({ notifications }: Params) {
  const [filter, setFilter] = useState<NotificationDrawerFilter>(NOTIFICATION_DRAWER_FILTER.ALL)

  const filteredNotifications = useMemo(() => {
    const filtered = filterNotificationsByReadState(notifications, filter)
    return sortNotificationsBySeverity(filtered)
  }, [filter, notifications])

  return {
    filter,
    setFilter,
    filteredNotifications,
  }
}
